import React from 'react'
import Button from '@material-ui/core/Button'

const ActionButton = ({
  groupEvent,
  paymentRequired,
  steps,
  activeStep,
  type,
  component,
  to,
  onClick,
}) => {
  const { isCanceled, registrationClosed, registrationFull } = groupEvent

  const registrationDisabled =
    isCanceled || registrationClosed || registrationFull

  const nextStep = steps[activeStep + 1]

  const label = (() => {
    if (isCanceled) return 'Event Canceled'
    if (registrationClosed) return 'Registration Closed'
    if (registrationFull) return 'Registration Full'
    if (nextStep && nextStep.name === 'Waiver') return 'Continue'
    if (paymentRequired) return 'Review and Pay'
    return 'Register'
  })()

  return (
    <Button
      variant="contained"
      color="primary"
      disabled={registrationDisabled}
      {...{ type, component, to, onClick }}
    >
      {label}
    </Button>
  )
}

export default ActionButton
